module.exports = __webpack_public_path__ + "static/media/ST12.742d7d8b.mp3";